module.exports = __webpack_public_path__ + "static/Syberia6-31a4fb3866561d5eaa435cf14a967a5c.webp";